import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer-wrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBackButton())
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          name: "backBtn",
          class: "btn back-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backButtonHandler && _ctx.backButtonHandler(...args)))
        }, " BACK "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "submit-wrapper",
      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = _ctx.isFormInvalid && !!_ctx.toolTip)),
      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false))
    }, [
      _createElementVNode("button", {
        name: "submitHandler",
        type: "submit",
        disabled: 
          (_ctx.isFormInvalid || _ctx.isSubmitDisabled) && !(_ctx.selectedSavedCardId > 0)
        ,
        class: "btn btn-primary save-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitHandler && _ctx.submitHandler(...args)))
      }, _toDisplayString(_ctx.saveBtnTxt), 9, _hoisted_2),
      (_ctx.toolTip && _ctx.isFormInvalid && !_ctx.isSubmitDisabled)
        ? (_openBlock(), _createBlock(_component_ToolTip, {
            "tooltip-text": _ctx.toolTip,
            key: _ctx.toolTip
          }, null, 8, ["tooltip-text"]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}